import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=6740ec88&scoped=true"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"
import style0 from "./PageHeader.vue?vue&type=style&index=0&id=6740ec88&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6740ec88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6740ec88')) {
      api.createRecord('6740ec88', component.options)
    } else {
      api.reload('6740ec88', component.options)
    }
    module.hot.accept("./PageHeader.vue?vue&type=template&id=6740ec88&scoped=true", function () {
      api.rerender('6740ec88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/PageHeader.vue"
export default component.exports